import * as React from 'react';
import { Client } from '../domain/client';
import { GetAllUsersEvent, GetAllUsersResult } from 'bloggers-backend/lib/users/domain';
import LinkInput from './LinkInput';
import { OutlinedTextFieldProps } from '@mui/material';
import { AppContext } from '../AppContext';

interface User {
  id: string;
  name: string;
}


interface LinkInputProps extends OutlinedTextFieldProps {
  onChoose: (user: User | null) => any;
  value: User | null
}

async function getAllUsers(client: Client) {
  const result = await client<GetAllUsersEvent, GetAllUsersResult>({
    event: 'getAllUsers',
    data: {}
  });

  if (result.success) {
    return result.value.data
  }

  throw new Error("getAllUser failed");
}

export function UserLinkInput({onChoose, value, ...props}: LinkInputProps) {
  const {client} = React.useContext(AppContext)

  return <LinkInput<User>
    onChoose={onChoose}
    value={value}
    getOptions={() => getAllUsers(client)}
    {...props}
  />
}
